module.exports = __webpack_public_path__ + "static/media/cookie1-angle.ca1b01f1.png";